/// <reference types="@types/googlemaps" />

import { Component, OnInit } from '@angular/core';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { MatIconRegistry } from "@angular/material/icon";
import { DomSanitizer } from "@angular/platform-browser";

import { Router } from '@angular/router';

import { TranslateService } from '@ngx-translate/core';
import { FacilitiesService } from '../services/facilities.service';
import { AnalysisService } from '../services/analysis.service';

import { ToastrService } from 'ngx-toastr';
import { ITimeline } from '../interfaces/timeline';
import { ITimelineItem } from '../interfaces/timelineItem';

@Component({
  selector: 'app-home-facility',
  templateUrl: './home-facility.component.html',
  styleUrls: ['./home-facility.component.css']
})
export class HomeFacilityComponent implements OnInit {

  //LocalStorage Elements.
  localFacilities = localStorage.getItem('localFacilities');
  localID = localStorage.getItem('localID');
  localModules = localStorage.getItem('localModules');

  id = JSON.parse(this.localID);
  facilities = JSON.parse(this.localFacilities);
  modules = JSON.parse(this.localModules);
  currentFacility = this.facilities[this.id];

  timelineMessage = '';

  //Icon NavBar
  markerImage: any = require("../image/logo/locationIcon.png")
  homeImage: any = require("../image/navbar/backHomeIcon.svg");
  summaryImage: any = require("../image/navbar/summary.svg");
  analysisImage: any = require("../image/navbar/analysis.svg");
  roiImage: any = require("../image/navbar/roi.svg");
  mdiImage: any = require("../image/navbar/mdi.svg");
  pprImage: any = require("../image/navbar/ppr.svg");

  lng: any;
  lat: any;
  zoom: number;

  timeline: ITimeline;

  itemTimeline: Array<ITimelineItem> = [];
  currentPage: number = 0;
  itemsNumberPerPage: number = 10;

  isOpen: boolean;

  _opened: boolean = false;

  constructor(
    private router: Router,
    private modalService: NgbModal,
    private translate: TranslateService,
    private facilitiesService: FacilitiesService,
    private analysisService: AnalysisService,
    private toastr: ToastrService,
    private modal: NgbActiveModal,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer
  ) {
    this.matIconRegistry.addSvgIcon("back", this.domSanitizer.bypassSecurityTrustResourceUrl(this.homeImage))
    this.matIconRegistry.addSvgIcon("all", this.domSanitizer.bypassSecurityTrustResourceUrl(this.summaryImage))
    this.matIconRegistry.addSvgIcon("Analysis", this.domSanitizer.bypassSecurityTrustResourceUrl(this.analysisImage))
    this.matIconRegistry.addSvgIcon("MDI", this.domSanitizer.bypassSecurityTrustResourceUrl(this.mdiImage))
    this.matIconRegistry.addSvgIcon("PPR", this.domSanitizer.bypassSecurityTrustResourceUrl(this.pprImage))
    this.matIconRegistry.addSvgIcon("ROI", this.domSanitizer.bypassSecurityTrustResourceUrl(this.roiImage))
  }

  ngOnInit() {

    this.translate.use(localStorage.getItem('localLanguage'));

    //Call Api of Facility Service  used go to HomeFacility component.
    this.isOpen = false;

    this.createGoogleMap();

    this.getTimeline(this.currentPage);

    //On refresh reload modules
    this.facilitiesService.getModules(this.id)
      .subscribe(
        data => {
          this.modules = data;
          localStorage.setItem('localModules', JSON.stringify(this.modules));
        },
        error => {
          this.router.navigate(['/errorPage']);
        });
    localStorage.removeItem('localIDElaboration');
    localStorage.removeItem('localStateAnalysis');
    localStorage.removeItem('localSurveyCompiled');
  }

  _toggleSidebar() {
    this._opened = !this._opened;
  }

  //Method used to create a map of current Structure.
  createGoogleMap() {
    if (navigator) {
      this.lng = this.currentFacility.myFacilities.Longitude;
      this.lat = this.currentFacility.myFacilities.Latitude;
      this.zoom = 13;
    }
  }

  //Method used to view icon arrow-Up.
  cardStructureOpen() {
    this.isOpen = true;
  }

  //Method used to view icon arrow-Down.
  cardStructureClose() {
    this.isOpen = false;
  }

  //API Return Timeline
  getTimeline(currentPage: number) {
    //Call Api of Analys service to get Timeline of current facility.
    this.analysisService.getTimeline(this.currentFacility.myFacilities.IdAnalysis, this.modules, currentPage, this.itemsNumberPerPage)
      .subscribe(
        data => {
          this.timeline = data;

          for (let item of this.timeline.items)
            this.itemTimeline.push(item);

          if ((data.currentPage + 1) * data.requestItemsNumberPerPage < data.totalItemsCount) this.getTimeline(data.currentPage + 1);
        },
        error => {
          this.timelineMessage = error.error;
          // this.router.navigate(['/errorPage']);
        }
      );
  }

}
